var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBackCaret = function SvgBackCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 .585a.577.577 0 0 0-.983-.418L.17 7.153A.593.593 0 0 0 0 7.57c0 .157.06.307.168.418l6.702 6.837c.11.115.253.174.41.174.152 0 .299-.059.41-.174a.602.602 0 0 0 0-.834L1.394 7.571 7.832 1C7.942.89 8 .74 8 .585Z",
    fill: "#444"
  })));
};
export default SvgBackCaret;